import * as PropTypes from 'prop-types';

export const TagPropTypes = PropTypes.shape({
    isFetching: PropTypes.bool,
    tag: PropTypes.object,
});
